import {
  EngagementDelegation,
  EngagementProxy,
} from "../../store/slices/EngagementDelegationSlice";

export const haveSameProxyDetails = (
  currentProxies: EngagementProxy[],
  initialProxies: EngagementProxy[],
  currentNotifications: Record<string, boolean>,
): boolean => {
  if (currentProxies.length !== initialProxies.length) return false;

  const currentProxiesByEmail = new Map(
    currentProxies.map((proxy) => [proxy.Email.toLowerCase(), proxy]),
  );

  return initialProxies.every((initialProxy) => {
    const currentProxy = currentProxiesByEmail.get(
      initialProxy.Email.toLowerCase(),
    );
    if (!currentProxy) return false;

    return (
      currentProxy.Name === initialProxy.Name &&
      currentProxy.Email === initialProxy.Email &&
      currentProxy.CreatorEmail?.toLowerCase() ===
      initialProxy.CreatorEmail?.toLowerCase() &&
      (currentNotifications[currentProxy.Email.toLowerCase()] ?? false) ===
        (Number(initialProxy.DelegateSendEmail) === 1)
    );
  });
};

export const getApprovalAmountError = (amount: string): string => {
  const amountValue = amount.replace(/[$,]/g, "");

  if (amountValue.includes(".")) {
    return "Approval amount cannot contain decimal values.";
  }

  if (amountValue.startsWith("-")) {
    return "Negative numbers are not allowed.";
  }

  if (!/^\d+$/.test(amountValue)) {
    return "Please enter a valid approval amount.";
  }

  if (Number(amountValue) === 0) {
    return "Approval amount must be greater than 0.";
  }
  if (amountValue.length > 6) {
    return "Approval amount cannot exceed 6 digits.";
  }

  return "";
};

export const hasUnsavedChanges = (
  engagementData: EngagementDelegation,
  isAutoApprove: boolean,
  approvalAmount: string,
  ownerNotifications: boolean,
  proxies: EngagementProxy[],
  proxyNotifications: Record<string, boolean>,
): boolean => {
  const initialAutoApprove =
    engagementData.IsAutoApprove.toLowerCase() === "yes";
  const approvalAmountChanged =
    isAutoApprove &&
    approvalAmount !== String(engagementData.AutoApproveAmount);

  return (
    isAutoApprove !== initialAutoApprove ||
    approvalAmountChanged ||
    ownerNotifications !== (Number(engagementData.PartnerSendEmail) === 1) ||
    !haveSameProxyDetails(
      proxies,
      engagementData.EngagementProxyDetails || [],
      proxyNotifications,
    )
  );
};

export const scrollToNotificationError = (): void => {
  document
    .querySelector<HTMLElement>(
      ".edit-engagement-delegation-modal .motif-modal-body",
    )
    ?.scrollTo({ top: 0, behavior: "smooth" });
};
